import {
  CUSTOMER_ALL,
  CUSTOMER_GET,
  CUSTOMER_PUT,
  CUSTOMER_DEL,
  CUSTOMER_POST,
  CUSTOMER_RESET,
  CUSTOMER_LOADING,
  CUSTOMER_ERROR,
} from '../../actions/types';

const initialState = {
  customer: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case CUSTOMER_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case CUSTOMER_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case CUSTOMER_POST:
      return { ...state, isLoading: false, isCompleted: true };
    case CUSTOMER_PUT: {
      const payloadId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && payloadId
          ? state.rows.map((r) =>
              (r._id || r.id) === payloadId ? { ...r, ...action.payload } : r,
            )
          : state.rows,
      };
    }
    case CUSTOMER_DEL: {
      const delId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && delId
          ? state.rows.filter((r) => (r._id || r.id) !== delId)
          : state.rows,
        total: state.rows && delId ? Math.max((state.total || 1) - 1, 0) : state.total,
      };
    }
    case CUSTOMER_RESET:
      return { customer: null, isLoading: true, isCompleted: true };
    case CUSTOMER_LOADING:
      return { ...state, isLoading: true, isCompleted: true };
    case CUSTOMER_ERROR:
      return { ...state, isLoading: false, isCompleted: false };
    default:
      return state;
  }
}
